/* ============================================================================
   JuiceBox Super Summer Sale 2026 — product-page mini bar behavior
   Companion to snippets/jb-sss-product-bar.liquid (see its header docs).
   Modules: countdown + end-of-sale watchdog, variant-reactive stock bar.
   Namespaced data-sssp-* / .jb-sssp__ — disjoint from the other two sale
   modules so nothing can collide.
   ========================================================================== */
(function () {
  var root = document.querySelector('.jb-sssp');
  if (!root) return;

  /* ==================== Countdown + end-of-sale watchdog ==================== */
  var endMs = parseInt(root.getAttribute('data-sssp-end'), 10) * 1000;
  var digits = {
    d: root.querySelector('[data-sssp-cd="d"]'),
    h: root.querySelector('[data-sssp-cd="h"]'),
    m: root.querySelector('[data-sssp-cd="m"]'),
    s: root.querySelector('[data-sssp-cd="s"]')
  };
  var tickTimer = null;

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function setDigit(key, value) {
    var el = digits[key];
    if (el && el.textContent !== value) el.textContent = value;
  }

  function tick() {
    var now = Date.now();
    if (now > endMs) {
      // Sale just ended on an open page: the card disappears.
      root.hidden = true;
      if (tickTimer) {
        clearInterval(tickTimer);
        tickTimer = null;
      }
      return;
    }
    var diff = Math.max(0, Math.floor((endMs - now) / 1000));
    setDigit('d', pad(Math.floor(diff / 86400)));
    setDigit('h', pad(Math.floor((diff % 86400) / 3600)));
    setDigit('m', pad(Math.floor((diff % 3600) / 60)));
    setDigit('s', pad(diff % 60));
  }

  tick();
  tickTimer = setInterval(tick, 1000);

  /* ==================== Variant-reactive stock bar + savings ==================== */
  // The Impact theme's <variant-picker> dispatches 'variant:change' on the
  // product form (bubbles to document) with detail.variant.id — but WITHOUT
  // metafields, so the per-variant states are baked into a JSON map by the
  // Liquid. Unknown ids (other products' forms) are ignored.
  var mapEl = root.querySelector('[data-sssp-variants]');
  var stock = root.querySelector('[data-sssp-stock]');
  var save = root.querySelector('[data-sssp-save]');
  if (mapEl && stock) {
    var map = {};
    try {
      map = JSON.parse(mapEl.textContent) || {};
    } catch (e) {
      map = {};
    }
    var fill = stock.querySelector('[data-sssp-fill]');
    var label = stock.querySelector('[data-sssp-stock-label]');
    var savePct = save && save.querySelector('[data-sssp-save-pct]');
    var saveAmt = save && save.querySelector('[data-sssp-save-amt]');

    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || !(variant.id in map)) return;
      var entry = map[variant.id] || {};

      // Stock bar row: no data → countdown-only look.
      if (!entry.l) {
        stock.hidden = true;
      } else {
        stock.className = 'jb-sssp__stock' + (entry.s ? ' ' + entry.s : '');
        if (fill) fill.style.width = entry.r + '%';
        if (label) label.textContent = entry.l;
        stock.setAttribute('aria-label', (entry.r <= 40 ? 'Fast ausverkauft – ' : '') + entry.l);
        stock.hidden = false;
      }

      // Savings row: only for discounted variants.
      if (save) {
        if (!entry.p) {
          save.hidden = true;
        } else {
          if (savePct) savePct.textContent = entry.p + '% Rabatt';
          if (saveAmt) saveAmt.textContent = 'Spare ' + entry.e;
          save.hidden = false;
        }
      }
    });
  }
})();
